export const AdminSetupScreenList = [
  { label: "Chart of Account", value: 1 },
  { label: "Production Companies", value: 2 },
  { label: "Set Units", value: 3 },
  { label: "Vendors", value: 4 },
  { label: "Shows", value: 5 },
  { label: "Currencies", value: 6 },
  { label: "Seasons", value: 7 }
];

export const lookupMasterTabs = [
  { tab_id: 16, tab_name: "Production Brand", lookup_type: "ProductionBrand" },
  { tab_id: 17, tab_name: "Content Structure", lookup_type: "ContentStructure" },
  { tab_id: 18, tab_name: "Content Type", lookup_type: "ContentType" },
  { tab_id: 19, tab_name: "Creative Production Type", lookup_type: "CreativeProductionType" },
  { tab_id: 20, tab_name: "Type of Release", lookup_type: "TypeOfRelease" },
  { tab_id: 21, tab_name: "First Release Platform", lookup_type: "FirstReleasePlatform" },
  { tab_id: 22, tab_name: "Vendor Destination", lookup_type: "VendorDestination" },
  { tab_id: 23, tab_name: "Territory", lookup_type: "Territory" },
  { tab_id: 24, tab_name: "Component", lookup_type: "Component" },
  { tab_id: 25, tab_name: "Localization Work Type", lookup_type: "LocWorkType" },
];

export const AdminSetupHboScreenList = [
  { label: "Vendors", value: 4 },
  { label: "Shows", value: 5 },
  { label: "Currencies", value: 6 },
  { label: "Seasons", value: 7 },
  { label: "Expenditure", value: 9 },
  { label: "Organization", value: 10 },
  // { label: "Task", value: 11 },
  { label: "Format", value: 12 },
  { label: "Language", value: 13 },
  ...lookupMasterTabs.map((tab) => ({ label: tab.tab_name, value: tab.tab_id })),
];

export const AdminSetupTenant3ScreenList = [
  { label: "Vendors", value: 4 },
  { label: "Shows", value: 5 },
  { label: "Seasons", value: 7 },
  { label: "Unit", value: 14 },
  { label: "Cost Center", value: 15 }
];

export const VendorAdminSetupHboScreenList = [
  { label: "Vendors", value: 4 }
];

export const adminMenuNonHBOTab= [
  { tab_id: 1, tab_name: "Chart of Accounts" },
  { tab_id: 2, tab_name: "Production Companies" },
  { tab_id: 3, tab_name: "Set Units" },
  { tab_id: 4, tab_name: "Vendors" },
  { tab_id: 5, tab_name: "Shows" },
  { tab_id: 6, tab_name: "Currencies" },
  { tab_id: 7, tab_name: "Seasons" }
]
export const adminMenuHBOTab= [       
  { tab_id: 4, tab_name: "Vendors" },
  { tab_id: 5, tab_name: "Shows" },
  { tab_id: 6, tab_name: "Currencies" },
  { tab_id: 7, tab_name: "Seasons" },
  { tab_id: 9, tab_name: "Expenditure" },
  { tab_id: 10, tab_name: "Organization" },
  // { tab_id: 11, tab_name: "Task" },
  { tab_id: 12, tab_name: "Format" },
  { tab_id: 13, tab_name: "Language" },
  ...lookupMasterTabs,
];
export const adminMenuTabTenant3= [       
  { tab_id: 4, tab_name: "Vendors" },
  { tab_id: 5, tab_name: "Shows" },
  { tab_id: 7, tab_name: "Seasons" },
  { tab_id: 14, tab_name: "Unit" },
  { tab_id: 15, tab_name: "Cost Center" }
];
export const vendorAdminMenuHBOTab= [       
  { tab_id: 4, tab_name: "Vendors" }
];